import { PromptPartType } from '../utils/common/types';

export const GPT_VERSION = 'gpt-4o-mini';
export const GPT_4_3K_VERSION = 'gpt-4-32k';

export const REPHRASE_PROMPT_PART = {
  type: PromptPartType.template,
  template: 'Rephrase a variant of the following text: "{{value}}".',
};

export const TONE_PROMPT_PART = {
  type: PromptPartType.template,
  template: ' Write in a {{value}} tone.',
};

export const TONE_PROP = {
  value: 'tone',
  analyticsValue: 'tone',
  promptPart: TONE_PROMPT_PART,
};

export const VALID_TONES = [
  'friendly',
  'luxury',
  'relaxed',
  'professional',
  'bold',
  'adventurous',
  'witty',
  'persuasive',
  'empathetic',
];
export const DEFAULT_TONE = 'friendly';

export const CATEGORY_ICON_PROPS = {
  width: 24,
  height: 24,
  background: 'transparent',
  fill: '#808080',
};

export const PRODUCT_CATEGORIES = [0, 6];
export const DESCRIPTION_CATEGORIES = [4, 14];
export const KEYWORDS_CATEGORIES = [10];

export const MAX_CHRS = 1000;
export const MIN_CHRS = 100;
export const TEXT_ROWS = 3;
export const MAX_NO_OF_RESULTS = 60;
export const MINUTES_FOR_MAX_NO_OF_RESULTS = 60;
export const LOCAL_STORAGE_RESULTS_KEY = 'qt_no_of_results';
export const LOCAL_STORAGE_SESSION_KEY = 'qt_session_id';
export const A_B_EXPERIMENT_ID = 'IWOo9n7bSJS-hp01rxjhvw';
export const ADS_GENERATOR_EXPERIMENT_ID = 't1L82hqST3qQ0qJ5yep2PA';
export const BIO_GENERATOR_EXPERIMENT_ID = 'WZnbaHaMR_-hjV9cLrIOqQ';

export const GENERAL_LANDING_CARD_SECTION_IMGS = [
  {
    src: 'https://cdn140.picsart.com/68721397183638063211.webp',
  },
  {
    src: 'https://cdn140.picsart.com/38242970981570235865.webp',
  },
  {
    src: 'https://cdn140.picsart.com/30068252809047449629.webp',
  },
  {
    src: 'https://cdn140.picsart.com/94188132819015905082.webp',
  },
];

export const quicktoolsLogoSrc =
  'https://pastatic.picsart.com/cms-pastatic/227d1042-e9d3-4f4d-b720-0e1505dfd52c.webp';

export const createPath = '/text/ai-writer/create/';
export const myWriterPath = '/text/ai-writer/my-writer/';

export const MAIN_CONTENT_ID = 'main-content';

export enum DeviceType {
  unknown,
  mobile,
  desktop,
}
